import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink, Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { OnChange } from 'react-final-form-listeners';
import TripsTabSupplier from '../../pages/Suppliers/Tabs/TripTabsSupplier';
import PassBookTabSupplier from '../../pages/Suppliers/Tabs/PassBookTabSupplier';

const TransportBookTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#0b1323',
  },
})(Tabs);
function TabPanel(props) {
  const { children, value, component, index, ...other } = props;
  let ComponentFromProp = component;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <ComponentFromProp />
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    textDecoration: 'none !important',
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#0b1323',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#0b1323',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#635ee7',
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    '&:focus': {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
  },
  demo2: {
    backgroundColor: '#2e1534',
  },
}));

const NavigationTabs = (props) => {

  const { location, defaultSelected, tabs, onChange, vehicle } = props;
  const classes = useStyles();

  let history = useHistory();

  let locationValue = useLocation();
  let path = locationValue && locationValue.pathname ? locationValue.pathname.split("/") : [];
  let currentId = path && path[path.length - 1] ? path[path.length - 1] : "";

  const [value, setValue] = React.useState(history.location.pathname);
  const [state, setState] = React.useState({});

  useEffect(() => {

    setValue(history.location.pathname);

    if (history && history.location && history.location.pathname && history.location.pathname.includes('parties')) {
      setState({
        partyId: currentId,
        id: 8,
        pageTitle: location && location.state && location.state.pageTitle ? location.state.pageTitle : 'Party View',
      })
    } else if (history && history.location && history.location.pathname && history.location.pathname.includes('suppliers')) {

      setState({
        vendorId: currentId,
        id: 8,
        pageTitle: location && location.state && location.state.pageTitle ? location.state.pageTitle : 'Vendor View',
      })
    }

  }, [history.location.pathname, location.state]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onChange && typeof onChange === 'function') {
      onChange(newValue);
    }
  };

  
  return (
    <div>
      <TransportBookTabs value={value} onChange={handleChange} aria-label="Page Tabs">
        {tabs && tabs.map((item, index) => {
          return (<AntTab label={item.name} value={item.path + currentId}
            to={{
              pathname: (item.path + currentId),
              state: {
                ...state
              }
            }} component={Link} />);
        })}

        {/* <AntTab label="Page One" value={"/suppliers/single-supplier/trips/161908296561526"} {...a11yProps(0)} />
        <AntTab label="Page Two" value={"/suppliers/single-supplier/passbook/161908296561526"} {...a11yProps(1)} /> */}

      </TransportBookTabs>

      {tabs && tabs.map((item, index) => {
        return (<TabPanel value={value} index={item.path + currentId} component={item.component} />);
      })}


      {/* <TabPanel value={"/suppliers/single-supplier/trips/161908296561526"} index={"/suppliers/single-supplier/trips/161908296561526"} component={TripsTabSupplier}>
        Page One
      </TabPanel>
      <TabPanel value={"/suppliers/single-supplier/passbook/161908296561526"} index={"/suppliers/single-supplier/passbook/161908296561526"} component={PassBookTabSupplier}>
        Page Two
      </TabPanel> */}


    </div>
  );
}
const NavigationTabsWithRouter = withRouter(NavigationTabs);
export default NavigationTabsWithRouter;